import { autoserialize } from 'cerialize';

export class CsmContact {
  @autoserialize name: string;
  @autoserialize email: string;
  @autoserialize phone: string;
  @autoserialize title: string;

  constructor(payload?: IStoreScheduleTime | null) {
    this.name = payload?.name;
    this.email = payload?.email;
    this.phone = payload?.phone;
    this.title = payload?.title;
  }
}

export interface IStoreScheduleTime {
  name?: string;
  email?: string;
  phone?: string;
  title?: string;
}
